<template lang="pug">
  a-list-item-meta(:description="`${course.teacher} | ${course.dep_cname } | ${course.time}`")
    a-space(slot="avatar" direction="vertical" align="center")
      a-button(@click.stop="updateCourse(course)" shape="circle" :type="coursesAdded?'primary':''" :icon="coursesAdded?'minus':'plus'")
      a-progress(v-show="!courseExtension.extensionNotExist" :width="35" type="circle" :percent="courseExtension['第一志願機率']")
        template(#format="percent")
          span(:style="{color: courseExtension['第一志願機率'] <= 0 ? 'gray' : 'black'}") {{showChance}}
    p.course-name(slot="title") {{course.cname}}

        //a-progress(:percentage="")
        //a(style="font-size: 6px") 中獎率
        //a(style="font-size: 16px; font-weight: bolder") {{ courseExtension['第一志願機率'] }}

</template>
<script>
// import {Print} from "@/fuckingJSExtension";

export default {
  name: 'course-entry-large-title',
  props: {
    course: {}
  },
  computed: {
    courseExtension() {
      let cid = this.course.id
      let courseExt = this.$store.state.coursesExtension[cid]
      return courseExt ?? {extensionNotExist: true}
    },
    coursesAdded: {
      get() {
        return this.allSelectedCourses.includes(this.course)
      },
      set() {
      }
    },
    showChance() {
      const courseAttr = this.courseExtension
      if (courseAttr['第一志願機率'] > 100) {
        return '保送😎'
      } else if (courseAttr['第一志願機率'] <= 0 && (courseAttr['第一志願機率'] > -10)) {
        return '滿惹😢'
      } else if (courseAttr['第一志願機率'] < -10) {
        return '加簽完辣乾'
      }
      return String(courseAttr['第一志願機率']) + '%'
    }
  }
}
</script>
<style>
.course-name {
  font-size: 20px;
  text-align: left;
  font-weight: bolder;
  line-height: 1;
}

.course-block {
  cursor: pointer;
}
</style>
